import { render, staticRenderFns } from "./contractBD.vue?vue&type=template&id=4ce63af8&scoped=true&"
import script from "./contractBD.vue?vue&type=script&lang=js&"
export * from "./contractBD.vue?vue&type=script&lang=js&"
import style0 from "./contractBD.vue?vue&type=style&index=0&id=4ce63af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce63af8",
  null
  
)

export default component.exports